module.exports = __webpack_public_path__ + "img/f9a0592.jpg";